/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".list-group-item[_ngcontent-%COMP%]:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.list-group-item[_ngcontent-%COMP%]{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.sortable-list-item[_ngcontent-%COMP%]{padding:5px}[_nghost-%COMP%]     .module-selection-field .ng-select .ng-control .ng-value-container .ng-input{display:none}.module-dropdown-container[_ngcontent-%COMP%]{height:55px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/main/measure/measure-module-dropdown/measure-module-dropdown.component.scss.shim.ngstyle.js.pre-build-optimizer.js